export default __webpack_public_path__ + "static/bg-solution-b88a458b6b2768097bac9b767860ce09.jpg";